<template>
  <!-- 此頁面是從鈴鐺通知中心內點擊連到的單篇貼文 -->
  <div class="one-post-div">
    <!-- 若貼文已被刪除則不要顯示 -->
    <template v-if="!getOnePostData.mainPostDelete">
      <PostWallCard v-if="getOnePostData.PostId" :postData="getOnePostData"></PostWallCard>
      <PostReplyList v-if="getOnePostLoadStatus" :replyListData="replyListData"></PostReplyList>
    </template>
    <h5 v-else class="text-center">此貼文已被刪除</h5>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import PostWallCard from '@/components/PostWall/PostWallCard/PostWallCard';
import PostReplyList from '@/components/SharedComponents/PostReplyList';
export default {
  name: 'OnePost',
  components: {
    PostWallCard,
    PostReplyList
  },
  created() {
    this.getApiOnePostData(this.$route.params.postId);
    this.showApiReply(this.$route.params.postId);
  },
  computed: {
    ...mapGetters('OnePostModule', ['getOnePostData', 'getOnePostLoadStatus']),
    replyListData() {
      return {
        postId: this.getOnePostData.PostId,
        likeCount: this.getOnePostData.LikeCount
      };
    }
  },
  methods: {
    ...mapActions('OnePostModule', ['getApiOnePostData']),
    ...mapActions('PostReplyListModule', ['showApiReply'])
  }
};
</script>

<style lang="scss">
.one-post-div {
  .fun-btn,
  .share-btn,
  .reply-btn {
    display: none;
  }
}
</style>
